var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column table-col"},[_c('div',[_vm._v(_vm._s(_vm.formattedCities))]),(_vm.item.cities_exclude.length)?_c('div',{staticClass:"mt-2"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v("Исключить: ")]),_vm._v(_vm._s(_vm.formattedCitiesExclude)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }